class LocaleCache {
  static getCachedDTF(locString, options = {}) {
    const key = JSON.stringify([locString, options]);
    let dtf = this._intlDTCache[key];
    if (!dtf) {
      dtf = new Intl.DateTimeFormat(locString, options);
      this._intlDTCache[key] = dtf;
    }
    return dtf;
  }
  static getCachedINF(locString, options) {
    const key = JSON.stringify([locString, options]);
    let inf = this._intlNumCache[key];
    if (!inf) {
      inf = new Intl.NumberFormat(locString, options);
      this._intlNumCache[key] = inf;
    }
    return inf;
  }
  static getCachedIntResolvedOptions(locString) {
    if (!this._intlResolvedOptionsCache[locString]) {
      this._intlResolvedOptionsCache[locString] = new Intl.DateTimeFormat(locString).resolvedOptions();
    }
    return this._intlResolvedOptionsCache[locString];
  }
  static getCachedLF(locString, opts = {}) {
    const key = JSON.stringify([locString, opts]);
    let dtf = this._intlLFCache[key];
    if (!dtf) {
      dtf = new Intl.ListFormat(locString, opts);
      this._intlLFCache[key] = dtf;
    }
    return dtf;
  }
  static getCachedRTF(locale, options = {}) {
    const key = JSON.stringify([locale, options]);
    let inf = this._intlRelCache[key];
    if (!inf) {
      inf = new Intl.RelativeTimeFormat(locale, options);
      this._intlRelCache[key] = inf;
    }
    return inf;
  }
  static reset() {
    this._sysLocaleCache = void 0;
    this._intlLFCache = {};
    this._intlDTCache = {};
    this._intlNumCache = {};
    this._intlRelCache = {};
    this._intlResolvedOptionsCache = {};
  }
  static systemLocale() {
    if (!this._sysLocaleCache) {
      this._sysLocaleCache = new Intl.DateTimeFormat().resolvedOptions().locale;
    }
    return this._sysLocaleCache;
  }
}
LocaleCache._intlDTCache = {};
LocaleCache._intlLFCache = {};
LocaleCache._intlNumCache = {};
LocaleCache._intlRelCache = {};
LocaleCache._intlResolvedOptionsCache = {};
export {
  LocaleCache
};
